import React from 'react';

import './HOCTable.scss';
import { useTranslation } from 'react-i18next';

import { ITablePagination } from '../../hooks/useTableHook/constants';
import { useTableReducerActions } from '../../hooks/useTableHook/useTableHook';
interface IHOCTableProps {
  rows: any;
  columns: any;
  pagination?: {
    info: ITablePagination;
    dispatch: Function;
  };
  resetSelected?: Function;
}

export const HOCTable: React.FC<IHOCTableProps> = ({
  rows,
  columns,
  pagination: isPagination = undefined,
  resetSelected = (): void => {},
}) => {
  const { t } = useTranslation();

  const loadPaginationControls = (
    <>
      {isPagination !== undefined &&
      isPagination.info.offset < isPagination.info.numTotal ? (
        <div className='load-more-table-btn '>
          <div
            className='btn btn-light'
            onClick={() => [
              resetSelected(),
              isPagination?.dispatch({ type: useTableReducerActions.paginate }),
            ]}
          >
            {t('common_table_paginate')}
          </div>
        </div>
      ) : null}
    </>
  );

  return (
    <>
      <table className='adaptive-table' id='results-table'>
        <thead>
          <tr>{columns}</tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
      {isPagination ? loadPaginationControls : null}
    </>
  );
};
